export default {"src":"/_next/static/media/debt.0ee052c4.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};